export default [
  {
    name: 'groups',
    path: '/settings/groups',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Grupos',
      icon: 'dvr',
      label: 'Grupos',
      roles: ['Admin']
    }
  }
]
